<template>
    <div>
        <Head title="編輯特價活動" />
        <ScrollTop />

        <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

        <div class="w-full flex flex-row items-center justify-end gap-4">
            <Button
                label="儲存"
                @click="savePromotion"
                :disabled="
                    !(
                        promotion.description &&
                        promotion.payload.type != null &&
                        (promotion.payload.condition.type == 'always' ||
                            (promotion.payload.condition.type == 'greater' &&
                                promotion.payload.condition.amount > 0)) &&
                        (duration.enabled == false ||
                            (duration.enabled == true &&
                                duration.start != null &&
                                duration.end != null))
                    )
                "
            />
        </div>

        <div class="border border-fh-gray-light mt-3 px-3">
            <div class="py-3">
                <div class="mt-1">
                    <label for="description">活動名稱</label>
                </div>
                <div class="mt-1">
                    <InputText
                        id="description"
                        v-model="promotion.description"
                        class="w-full"
                    />
                </div>
            </div>

            <div class="py-3">
                <div class="mt-1">
                    <label>促銷類型</label>
                </div>
                <div class="mt-1">
                    <SelectButton
                        v-model="promotion.payload.type"
                        :options="promotion_types"
                        optionLabel="name"
                        optionValue="code"
                    />
                </div>
            </div>

            <div class="py-3">
                <div class="mt-1">
                    <label>活動期間設定</label>
                </div>
                <div class="mt-1">
                    <div class="flex flex-row gap-8">
                        <SelectButton
                            v-model="duration.enabled"
                            :options="durations"
                            optionLabel="name"
                            optionValue="code"
                        />

                        <div class="flex flex-row items-center gap-4">
                            <div>
                                開始日期
                                <Calendar
                                    v-model="duration.start"
                                    :maxDate="duration.end"
                                    selectionMode="single"
                                    :disabled="!duration.enabled"
                                />
                            </div>
                            <div>
                                結束日期
                                <Calendar
                                    v-model="duration.end"
                                    :minDate="duration.start"
                                    selectionMode="single"
                                    :disabled="!duration.enabled"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="promotion.payload.type == 'order'">
                <div class="py-3">
                    <div class="mt-1">
                        <label>選擇訂單折扣條件</label>
                    </div>
                    <div class="mt-1">
                        <div class="flex flex-row gap-8">
                            <SelectButton
                                v-model="promotion.payload.condition.type"
                                :options="conditions"
                                optionLabel="name"
                                optionValue="code"
                            />

                            <div class="flex flex-row items-center gap-4">
                                <label for="amount">消費金額超過</label>
                                <InputNumber
                                    id="amount"
                                    mode="decimal"
                                    prefix="$"
                                    v-model="promotion.payload.condition.amount"
                                    :disabled="
                                        promotion.payload.condition.type !=
                                        'greater'
                                    "
                                    class="w-64"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="py-3">
                    <div class="mt-1">
                        <label>適用商品</label>
                    </div>
                    <div class="mt-1">
                        <div class="flex flex-row gap-4 items-center">
                            <div class="flex flex-row items-center gap-2">
                                <Checkbox
                                    id="delivery_normal"
                                    v-model="
                                        promotion.payload.order_discount
                                            .delivery_type.normal
                                    "
                                    :binary="true"
                                />
                                <label for="delivery_normal">常溫商品</label>
                            </div>
                            <div class="flex flex-row items-center gap-2">
                                <Checkbox
                                    id="delivery_refrigerated"
                                    v-model="
                                        promotion.payload.order_discount
                                            .delivery_type.refrigerated
                                    "
                                    :binary="true"
                                />
                                <label for="delivery_refrigerated"
                                    >冷藏商品</label
                                >
                            </div>
                            <div class="flex flex-row items-center gap-2">
                                <Checkbox
                                    id="delivery_frozen"
                                    v-model="
                                        promotion.payload.order_discount
                                            .delivery_type.frozen
                                    "
                                    :binary="true"
                                />
                                <label for="delivery_frozen">冷凍商品</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="py-3">
                    <div class="mt-1">
                        <label>訂單折扣設定</label>
                    </div>
                    <div class="mt-1">
                        <div class="flex flex-row gap-8">
                            <SelectButton
                                v-model="promotion.payload.order_discount.type"
                                :options="order_discounts"
                                optionLabel="name"
                                optionValue="code"
                            />

                            <div
                                v-if="
                                    promotion.payload.order_discount.type ==
                                    'percentage_off'
                                "
                                class="flex flex-row items-center gap-4"
                            >
                                <label for="amount">折數</label>
                                <InputNumber
                                    showButtons
                                    :step="1"
                                    :max="100"
                                    :min="1"
                                    id="amount"
                                    mode="decimal"
                                    suffix="%"
                                    v-model="
                                        promotion.payload.order_discount
                                            .percentage
                                    "
                                    class="w-64"
                                />
                            </div>

                            <div
                                v-if="
                                    promotion.payload.order_discount.type ==
                                    'fixed_amount'
                                "
                                class="flex flex-row items-center gap-4"
                            >
                                <label for="amount">金額</label>
                                <InputNumber
                                    id="amount"
                                    mode="decimal"
                                    prefix="$"
                                    v-model="
                                        promotion.payload.order_discount.amount
                                    "
                                    class="w-64"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <div
                v-if="promotion.payload.type == 'price'"
                class="py-3 flex flex-row flex-nowrap gap-2"
            >
                <div>
                    <Checkbox
                        id="show_event_tag"
                        v-model="promotion.payload.event_tag.enabled"
                        :binary="true"
                    />
                </div>
                <div class="flex flex-col gap-1">
                    <div>
                        <label for="show_event_tag"
                            >於商品頁面顯示活動名稱</label
                        >
                    </div>
                    <div
                        v-if="promotion.payload.event_tag.enabled"
                        class="mt-1"
                    >
                        顯示名稱：<InputText
                            id="description"
                            v-model="promotion.payload.event_tag.name"
                            class="w-full"
                        />
                    </div>
                </div>
            </div>

            <div v-if="promotion.payload.type == 'price'" class="py-3">
                <div class="mt-1">
                    <label>選擇特價商品</label>
                </div>
                <div class="mt-1">
                    <DataTable
                        :paginator="true"
                        :rows="10"
                        :rowsPerPageOptions="[10, 20, 50]"
                        :value="filteredData"
                        :selection.sync="selectedProducts"
                    >
                        <template #header>
                            <div class="flex items-center">
                                <div>
                                    已選擇
                                    {{ promotion.payload.products.length }} 個
                                </div>
                                <div class="ml-14">
                                    <Checkbox
                                        id="show_checked"
                                        v-model="show_checked"
                                        :binary="true"
                                    />
                                    <label for="city1">僅顯示已勾選商品</label>
                                </div>

                                <div
                                    class="flex flex-row items-center gap-2 ml-auto"
                                >
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search" />
                                        <InputText
                                            class="w-52"
                                            v-model="products_search"
                                            placeholder="搜尋商品"
                                        />
                                    </span>
                                </div>
                            </div>
                        </template>
                        <Column
                            headerClass="w-11"
                            selectionMode="multiple"
                        ></Column>
                        <Column headerClass="w-16" field="type" header="類型">
                            <template #body="slotProps">
                                <template v-if="slotProps.data.type == 'pack'"
                                    >組合包</template
                                >
                                <template v-if="slotProps.data.type == 'add-on'"
                                    >加購品</template
                                >
                                <template
                                    v-if="slotProps.data.type == 'merchandise'"
                                    >商品</template
                                >
                            </template>
                        </Column>
                        <Column headerClass="w-14" field="images" header="圖片">
                            <template #body="slotProps">
                                <template
                                    v-if="
                                        Array.isArray(slotProps.data.images) &&
                                        slotProps.data.images.length > 0
                                    "
                                >
                                    <div
                                        class="w-[50px] h-[50px] bg-fh-gray-light flex items-center justify-center bg-cover bg-center"
                                        :style="{
                                            'background-image':
                                                'url(\'/storage/product-images/' +
                                                slotProps.data.images[0] +
                                                '/50.jpg\')',
                                        }"
                                    ></div>
                                </template>
                                <template v-else>
                                    <div
                                        class="w-[50px] h-[50px] bg-fh-gray-light flex items-center justify-center"
                                    >
                                        無
                                    </div>
                                </template>
                            </template>
                        </Column>
                        <Column
                            headerClass="w-52"
                            field="name"
                            header="商品名稱"
                            sortable
                        >
                        </Column>
                        <Column
                            headerClass="w-24"
                            field="settings.discount.original_price"
                            header="原始價格"
                            sortable
                        >
                            <template #body="slotProps">
                                {{
                                    slotProps.data.settings.discount
                                        .original_price
                                        | commaFormat
                                        | priceFormat
                                }}
                            </template>
                        </Column>
                        <Column
                            headerClass="w-24"
                            field="settings.discount.discount_price"
                            header="特價價格"
                            sortable
                        >
                            <template #body="slotProps">
                                <span class="text-red">{{
                                    slotProps.data.settings.discount
                                        .discount_price
                                        | commaFormat
                                        | priceFormat
                                }}</span>
                            </template>
                        </Column>
                        <Column
                            headerClass="w-24"
                            field="settings.discount.original_cv"
                            header="原始CV"
                            sortable
                        >
                            <template #body="slotProps">
                                {{
                                    slotProps.data.settings.discount.original_cv
                                        | commaFormat
                                }}
                            </template>
                        </Column>
                        <Column
                            headerClass="w-24"
                            field="settings.discount.discount_cv"
                            header="特價CV"
                            sortable
                        >
                            <template #body="slotProps">
                                <span class="text-red">{{
                                    slotProps.data.settings.discount.discount_cv
                                        | commaFormat
                                }}</span>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from "../Layout";
import ScrollTop from "primevue/scrolltop";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Checkbox from "primevue/checkbox";
import SelectButton from "primevue/selectbutton";
import InputNumber from "primevue/inputnumber";
import Calendar from "primevue/calendar";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default {
    layout: Layout,
    components: {
        ScrollTop,
        Breadcrumb,
        Button,
        InputText,
        Checkbox,
        SelectButton,
        InputNumber,
        Calendar,
        DataTable,
        Column,
    },
    props: {
        promotion: Object,
    },
    filters: {
        priceFormat: function (value) {
            return "$" + value;
        },
        commaFormat: function (value) {
            return value
                .toString()
                .replace(
                    /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
                    function (all, pre, groupOf3Digital) {
                        return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
                    }
                );
        },
    },
    data() {
        return {
            breadcrumb_home: {
                label: "行銷管理",
                disabled: true,
            },
            breadcrumb_paths: [
                {
                    label: "促銷",
                    to: this.$page.props.from
                        ? decodeURIComponent(atob(this.$page.props.from))
                        : route("admin.promotion"),
                },
                {
                    label: "編輯活動",
                    disabled: true,
                },
            ],
            duration: {
                enabled: this.promotion.duration.enabled,
                start:
                    this.promotion.duration.start == null
                        ? null
                        : new Date(this.promotion.duration.start),
                end:
                    this.promotion.duration.end == null
                        ? null
                        : new Date(this.promotion.duration.end),
            },
            selectedProducts: [],
            products_search: "",
            promotion_types: [
                { name: "特價", code: "price" },
                { name: "訂單折扣", code: "order" },
            ],
            conditions: [
                { name: "無條件", code: "always" },
                { name: "滿額", code: "greater" },
            ],
            durations: [
                { name: "永不過期", code: false },
                { name: "設定日期", code: true },
            ],
            order_discounts: [
                { name: "打折", code: "percentage_off" },
                { name: "固定金額", code: "fixed_amount" },
            ],
            show_checked: false,
        };
    },
    computed: {
        filteredData() {
            if (this.show_checked) {
                return this.selectedProducts;
            } else {
                return this.$page.props.all_products.filter((product) => {
                    return (
                        product.name.includes(this.products_search) ||
                        product.type.includes(this.products_search)
                    );
                });
            }
        },
    },
    methods: {
        savePromotion() {
            let payload = {
                description: this.promotion.description,
                payload: {
                    type: this.promotion.payload.type,
                    condition: this.promotion.payload.condition,
                    order_discount: this.promotion.payload.order_discount,
                    event_tag: this.promotion.payload.event_tag,
                    products: this.selectedProducts.map((item) => {
                        return {
                            type: item.type,
                            id: item.id,
                        };
                    }),
                },
                duration: {
                    enabled: this.duration.enabled,
                    start: this.duration.enabled ? this.duration.start : null,
                    end: this.duration.enabled ? this.duration.end : null,
                },
            };

            this.$inertia.post(
                route("admin.promotion.save", this.promotion.id),
                {
                    payload: payload,
                    to: this.$page.props.from
                        ? decodeURIComponent(atob(this.$page.props.from))
                        : route("admin.promotion"),
                }
            );
        },
    },

    mounted() {
        this.selectedProducts = this.$page.props.all_products.filter(
            (product) => {
                return this.promotion.payload.products.some((item) => {
                    return item.id == product.id && item.type == product.type;
                });
            }
        );
    },
};
</script>

<style lang="postcss">
.p-breadcrumb {
    @apply border-0;
}
</style>
